(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var STAR_PATH =
    'M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z';
  var starSvgTemplate = document.querySelector('[data-tt-star-svg-tpl]');

  function createSvgIcon(extraClass) {
    if (starSvgTemplate && starSvgTemplate.content && starSvgTemplate.content.firstElementChild) {
      var svg = starSvgTemplate.content.firstElementChild.cloneNode(true);
      svg.setAttribute('class', 'tt-star-rating__svg');
      return svg;
    }

    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'tt-star-rating__svg');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', STAR_PATH);
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    return svg;
  }

  function createIconShell(extraClass) {
    var shell = document.createElement('span');
    shell.className = 'tt-star-rating__icon' + (extraClass ? ' ' + extraClass : '');
    shell.appendChild(createSvgIcon(extraClass));
    return shell;
  }

  function buildStarCell(fillPct) {
    var cell = document.createElement('span');
    cell.className = 'tt-star-rating__star';
    cell.appendChild(createIconShell('tt-star-rating__icon--empty'));
    var fill = document.createElement('span');
    fill.className = 'tt-star-rating__fill';
    fill.style.width = fillPct + '%';
    fill.appendChild(createIconShell('tt-star-rating__icon--full'));
    cell.appendChild(fill);
    return cell;
  }

  function clampRating(rating) {
    return Math.max(0, Math.min(5, parseFloat(rating) || 0));
  }

  function fillPercent(rating, index) {
    var fill = clampRating(rating) - (index - 1);
    return Math.round(Math.max(0, Math.min(1, fill)) * 1000) / 10;
  }

  function buildRatingElement(rating, options) {
    options = options || {};
    var value = clampRating(rating);
    var size = options.size || 'md';
    var label = options.label || value.toFixed(1) + ' out of 5 stars';
    var wrap = document.createElement('span');
    wrap.className = 'tt-star-rating tt-star-rating--' + size;
    if (options.className) wrap.className += ' ' + options.className;
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', label);

    for (var i = 1; i <= 5; i++) {
      wrap.appendChild(buildStarCell(fillPercent(value, i)));
    }

    return wrap;
  }

  function ratingToHtml(rating, options) {
    var el = buildRatingElement(rating, options);
    var holder = document.createElement('div');
    holder.appendChild(el);
    return holder.innerHTML;
  }

  function mountRating(el, rating, options) {
    if (!el) return;
    el.textContent = '';
    el.appendChild(buildRatingElement(rating, options));
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function starsHtml(rating) {
    return ratingToHtml(rating, { size: 'md' });
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).slice(0, 2);
    return parts.map(function (p) { return p.charAt(0).toUpperCase(); }).join('') || '?';
  }

  function renderReview(review) {
    var images = (review.images || []).map(function (img) {
      return '<a class="tt-reviews-page__photo" href="' + escapeHtml(img.url) + '" target="_blank" rel="noopener">' +
        '<img src="' + escapeHtml(img.url) + '" alt="" loading="lazy">' +
      '</a>';
    }).join('');

    return (
      '<article class="tt-reviews-page__item">' +
        '<div class="tt-reviews-page__item-top">' +
          '<span class="tt-reviews-page__avatar" aria-hidden="true">' + escapeHtml(initials(review.authorName)) + '</span>' +
          '<div class="tt-reviews-page__item-id">' +
            '<span class="tt-reviews-page__item-name">' + escapeHtml(review.authorName) + '</span>' +
            '<time datetime="' + escapeHtml(review.createdAt) + '">' + escapeHtml(formatDate(review.createdAt)) + '</time>' +
          '</div>' +
          starsHtml(review.rating) +
        '</div>' +
        '<p class="tt-reviews-page__item-text">' + escapeHtml(review.comment) + '</p>' +
        (images ? '<div class="tt-reviews-page__item-photos">' + images + '</div>' : '') +
      '</article>'
    );
  }

  function renderSummary(root, reviews) {
    var summary = root.querySelector('[data-tt-reviews-summary]');
    if (!summary || !reviews.length) return;

    var total = reviews.reduce(function (sum, r) { return sum + (parseInt(r.rating, 10) || 0); }, 0);
    var avg = total / reviews.length;

    var avgEl = summary.querySelector('[data-tt-reviews-avg]');
    var starsEl = summary.querySelector('[data-tt-reviews-avg-stars]');
    var countEl = summary.querySelector('[data-tt-reviews-count]');

    if (avgEl) avgEl.textContent = avg.toFixed(1);
    if (starsEl) {
      mountRating(starsEl, avg, {
        size: 'lg',
        className: 'tt-star-rating--summary',
        label: avg.toFixed(1) + ' out of 5 stars',
      });
    }
    if (countEl) countEl.textContent = 'Based on ' + reviews.length + ' review' + (reviews.length === 1 ? '' : 's');

    summary.hidden = false;
  }

  function loadReviews(root, listEl) {
    fetch('/apps/trident-cockpit/reviews', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data.ok || !data.reviews || !data.reviews.length) {
          listEl.innerHTML = '<p class="tt-reviews-page__state">No published reviews yet. Be the first to share your experience.</p>';
          return;
        }
        listEl.innerHTML = data.reviews.map(renderReview).join('');
        renderSummary(root, data.reviews);
      })
      .catch(function () {
        listEl.innerHTML = '<p class="tt-reviews-page__state">Reviews could not be loaded right now.</p>';
      });
  }

  function paintInteractiveStar(button, fillPct) {
    var fill = button.querySelector('.tt-star-rating__fill');
    if (fill) fill.style.width = fillPct + '%';
  }

  function initStars(root) {
    var wrap = root.querySelector('[data-tt-stars]');
    var hidden = root.querySelector('[data-tt-rating-value]');
    if (!wrap || !hidden) return;

    var stars = Array.prototype.slice.call(wrap.querySelectorAll('[data-tt-star]'));

    function paint(value) {
      stars.forEach(function (star) {
        var starValue = parseInt(star.dataset.ttStar, 10);
        var on = starValue <= value;
        star.classList.toggle('is-on', on);
        paintInteractiveStar(star, on ? 100 : 0);
      });
    }

    function selected() {
      return parseInt(hidden.value, 10) || 0;
    }

    stars.forEach(function (star) {
      var starValue = parseInt(star.dataset.ttStar, 10);

      star.addEventListener('mouseenter', function () { paint(starValue); });
      star.addEventListener('focus', function () { paint(starValue); });
      star.addEventListener('click', function () {
        hidden.value = String(starValue);
        stars.forEach(function (s) {
          s.setAttribute('aria-checked', parseInt(s.dataset.ttStar, 10) === starValue ? 'true' : 'false');
        });
        paint(starValue);
      });
    });

    wrap.addEventListener('mouseleave', function () { paint(selected()); });
    wrap.addEventListener('blur', function () { paint(selected()); }, true);

    paint(0);
  }

  function resetStars(root) {
    var hidden = root.querySelector('[data-tt-rating-value]');
    if (hidden) hidden.value = '';
    root.querySelectorAll('[data-tt-star]').forEach(function (star) {
      star.classList.remove('is-on');
      star.setAttribute('aria-checked', 'false');
      paintInteractiveStar(star, 0);
    });
  }

  function initForm(root, form) {
    var msgEl = form.querySelector('[data-tt-review-msg]');
    var fileInput = form.querySelector('[data-tt-review-images]');
    var ratingInput = form.querySelector('[data-tt-rating-value]');
    var submitBtn = form.querySelector('[type="submit"]');

    function showError(message) {
      msgEl.textContent = message;
      msgEl.hidden = false;
      msgEl.classList.add('tt-reviews-page__msg--error');
    }

    fileInput.addEventListener('change', function () {
      if (fileInput.files.length > 3) {
        showError('Please choose up to 3 images only.');
        fileInput.value = '';
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      msgEl.hidden = true;
      msgEl.classList.remove('tt-reviews-page__msg--error');

      if (!ratingInput.value) {
        showError('Please choose a star rating.');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (fileInput.files.length > 3) {
        showError('Please choose up to 3 images only.');
        return;
      }

      submitBtn.disabled = true;

      var body = new FormData(form);
      if (fileInput.files.length) {
        body.delete('images');
        Array.prototype.forEach.call(fileInput.files, function (file) {
          body.append('images', file);
        });
      }

      fetch('/apps/trident-cockpit/reviews', {
        method: 'POST',
        body: body,
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data.ok) {
            throw new Error((result.data && result.data.error) || 'Could not submit review');
          }
          form.reset();
          resetStars(root);
          msgEl.textContent = result.data.message || 'Thank you for your review.';
          msgEl.hidden = false;
        })
        .catch(function (error) {
          showError(error.message || 'Could not submit review.');
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-tt-customer-reviews]').forEach(function (root) {
      var listEl = root.querySelector('[data-tt-reviews-list]');
      if (listEl) loadReviews(root, listEl);
      initStars(root);
      var form = root.querySelector('[data-tt-review-form]');
      if (form) initForm(root, form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
